// deep copy nested object/array
export const deepCopyObject = (input: any): any => {
  const newObj = Array.isArray(input) ? [] : {}
  for (const key in input) {
    const val = input[key]
    if (val) {
      if (typeof val === 'object') {
        newObj[key] = deepCopyObject(val)
      } else {
        newObj[key] = val
      }
    } else {
      newObj[key] = val
    }
  }
  return newObj
}

export interface ObjectUtils {
  deepCopyObject: typeof deepCopyObject
}
